<template>
  <div class="formGroup" :data-layout="layout">
    <div class="formGroup__body">
      <!-- <formLabel :label="label" :validation="validation" :required="isRequired"></formLabel> -->
      <div class="radioGroup" :class="design">
        <label
          class="radio"
          v-for="option in options"
          :key="option.value"
          :data-error="errors.has(name)"
        >
          <input
            v-validate="validation"
            :name="name"
            type="radio"
            class="radio__input"
            :value="option.value"
            :checked="checked === option.value"
            @change="update($event)"
          >
          <span class="radio__description"><span>{{ option.text }}</span></span>
        </label>
      </div>
    </div>
    <div class="formGroup__footer">
      <slot></slot>
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-radio',
  props: {
    value: { type: [String, Number, Object], default: ''},
    options: { type: Array, required: true },
    design: { type: String, default: 'radio' }, // 'radio' or 'button'
    defaultNoCheck: { type: Boolean, default: false },
    isRequired: {type: Boolean, default: false},
    layout: { type: String, default: 'column' },
    label: { type: String, default: '' },
    validation: {
      type: [String, Object],
      default: () => ({
        rules: {}
      })
    },
    name: { type: String, required: true },
  },
  computed: {
    checked() {
      // return !this.value && !this.defaultNoCheck ? this.options[0].value : this.value
      return this.value
    }
  },
  methods: {
    update($event) {
      if ($event) {
        this.$emit('input', $event.target.value)
        this.$emit('change', $event.target.value)
        this.$emit('validate', this.errors)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.formGroup {
  margin: 10px 0 0;
  .radioGroup {
    display: flex;
  }
  label.radio {
    flex: 1 1 50%;
    max-width: 50%;
    margin: 0 7px 0 0;
    background: #FFFFFF;
    border: 1px solid #DCDFE2;
    border-radius: 40px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
  .radio__input {
    display: none;
  }
  .radio__description {
    flex: 1 1 auto;
    padding: 13px 0;
    color: #DCDFE2;
    font-weight: normal;
    text-align: center;
    line-height: 1;
  }
  .radio__input:checked {
    & + .radio__description {
      color: #32373F;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/formRadio.vue